import React from 'react';
import { FiArrowUpRight, FiCode, FiLayers, FiZap } from 'react-icons/fi';

const values = [
  { icon: <FiZap />, title: 'Performance first', text: 'SSR, lazy loading, code splitting, and measurable Lighthouse-led improvements.' },
  { icon: <FiLayers />, title: 'Systems that scale', text: 'Reusable UI libraries, clear API contracts, validation, and modular service design.' },
  { icon: <FiCode />, title: 'End-to-end ownership', text: 'From interface and state to APIs, integrations, testing, and cloud delivery.' }
];

export default function About() {
  return (
    <section className="section about" id="About">
      <div className="section__head"><span className="section__number">01</span><p className="eyebrow">ABOUT</p><h2>Engineering with a product mindset.</h2></div>
      <div className="about__grid">
        <div className="about__statement">
          <p>I’m a full-stack developer who cares as much about the user’s next click as the architecture behind it.</p>
          <p className="muted">I work across modern frontend systems and dependable backend services—partnering with product, QA, and design to ship software that performs in the real world.</p>
          <a className="text-link" href="mailto:himanshu.singh5296@gmail.com">Start a conversation <FiArrowUpRight /></a>
        </div>
        <div className="about__values">{values.map(v => <article key={v.title}><span>{v.icon}</span><div><h3>{v.title}</h3><p>{v.text}</p></div></article>)}</div>
      </div>
    </section>
  );
}
